import React from "react"

const FeatureTick = ({ children, className = "" }) => {
  return <li className={`feature-tick ${className}`}>{children}</li>
}

export default FeatureTick
